/*eslint-disable*/
import api from '../'

class vocabularyWordsRusGameItems {
    static getItemsByRequest (params) {
        return api.axios.get('/vocabularyWordsRus/items', { params }).then(response => response.data.items);
    }
}

export default vocabularyWordsRusGameItems;